module.exports = __webpack_public_path__ + "static/media/adjuge-fr.d50dac28.png";